module.exports = __webpack_public_path__ + "static/media/Webscape.bab0161a.png";